import { render, staticRenderFns } from "./MoreInfoSubs.vue?vue&type=template&id=4023d1aa&"
import script from "./MoreInfoSubs.vue?vue&type=script&lang=js&"
export * from "./MoreInfoSubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports